import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    ordinary: 'Fleurs : 45$ min. Périssables en 3 jours.',
    musefrase: 'MuseFraise : 9,97$. Un souvenir gravé.'
  }, {
    ordinary: 'Chocolat industriel : Sans âme, vu partout.',
    musefrase: "L'Artisanat : Fait par TOI. Zéro équivalent."
  }, {
    ordinary: "Le stress : File d'attente infinie dimanche.",
    musefrase: 'Le calme : Prêt en 10 min chez toi.'
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 max-w-6xl mx-auto" data-id="element-36">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-37">
        <p className="text-base sm:text-lg md:text-xl text-gray-700 text-center mb-6 md:mb-12 font-lato max-w-3xl mx-auto" data-id="element-38">
          Nous sommes en 2026. Offrir un bouquet à 50$ qui sera fané mercredi
          prochain ? C'est l'option par défaut.
        </p>

        <div className="hidden md:grid md:grid-cols-2 gap-6 mb-8" data-id="element-39">
          <div className="text-center" data-id="element-40">
            <h3 className="font-playfair text-2xl font-bold text-gray-500 mb-4" data-id="element-41">
              Le choix ordinaire
            </h3>
          </div>
          <div className="text-center" data-id="element-42">
            <h3 className="font-playfair text-2xl font-bold text-rose-gold mb-4" data-id="element-43">
              Le choix MuseFraise
            </h3>
          </div>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-44">
          {comparisons.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4" data-id="element-45">
              <div className="bg-gray-100 rounded-lg md:rounded-xl p-4 md:p-6 flex items-center gap-2 md:gap-3" data-id="element-46">
                <XIcon className="w-5 h-5 md:w-6 md:h-6 text-gray-400 flex-shrink-0" data-id="element-47" />
                <p className="text-sm md:text-base text-gray-600 font-lato" data-id="element-48">
                  {item.ordinary}
                </p>
              </div>
              <div className="bg-blush rounded-lg md:rounded-xl p-4 md:p-6 flex items-center gap-2 md:gap-3 border-2 border-rose-gold" data-id="element-49">
                <CheckIcon className="w-5 h-5 md:w-6 md:h-6 text-rose-gold flex-shrink-0" data-id="element-50" />
                <p className="text-sm md:text-base text-burgundy font-lato font-semibold" data-id="element-51">
                  {item.musefrase}
                </p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}